import {DatePipe} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Component, OnInit, Output} from '@angular/core';
import {CarrierService} from 'app/services/carrier.service';
import {Router, ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AuthWebService} from 'app/services/authweb.service';
import {CorspdcService} from 'app/services/corspdc.service';
import {UtilityServiceService} from 'app/services/utility-service.service';
import {EventEmitter} from 'protractor';
import {CarriertransactionService} from 'app/services/carriertransaction.service';
// import * as jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import autoTable from 'jspdf-autotable';

var jsPDF = require('jspdf');
require('jspdf-autotable');

@Component({
    selector: 'app-statement',
    templateUrl: './statement.component.html',
    styleUrls: ['./statement.component.css']
})
export class StatementComponent implements OnInit {

    isLoading: boolean = false;
    isEmpty: boolean = false;
    listTransactions: any = [];
    user: any = {};
    page = 1
    dateTo;
    dateFrom;
    count: number = 0;
    currentPage = 1;
    pageSize: number = 10;
    debtoraccount: any = {};
    accountnumber: string;
    carrierid: string;
    message = 'Submitting your request, please wait...';
    person_id: string;

    // @Output() transData = new EventEmitter();


    constructor(private carrierService: CarrierService, private authWebService: AuthWebService, private router: Router, public utility: UtilityServiceService, public transData: CarriertransactionService,
                private toaster: ToastrService, private datepipe: DatePipe, private route: ActivatedRoute, private crspdService: CorspdcService) {
        this.user = (this.authWebService.userData) ? this.authWebService.userData.User : null;
        
    }


    ngOnInit() {

        this.route.paramMap.subscribe(params => {
            this.accountnumber = params.get('id');
            this.utility.page = 1;
            this.utility.setShowStatementFooter(true);
            this.carrierid = params.get('carrierid');
        })
        // this.accountnumber = this.route.snapshot.paramMap.get("id");
        //console.log('the account number is: ' + this.accountnumber);
        //console.log('the carrierid ' +  this.carrierid);
        this.getDebtorAccount(this.accountnumber);
        this.getCarrier();
        this.onReset();

    }

    onChange = () => {

        // this.pageSize =
        this.loadAccounts(this.accountnumber, this.dateFrom, this.dateTo);
    }


    onReset = () => {

        let date = new Date();

        this.dateTo = this.datepipe.transform(date, 'yyyy-MM-dd');
        var pastthreemonths = new Date(date.setDate(date.getDate() - 90));
        this.dateFrom = this.datepipe.transform(pastthreemonths, 'yyyy-MM-dd');
        this.loadAccounts(this.accountnumber, this.dateFrom, this.dateTo);

    }

    loadAccounts = (custcode: string, datefrom: Date, dateto: Date) => {

        this.isLoading = true;
        //console.log('user.ID = ', this.user.Id);
        this.carrierService.getlisttranscation(custcode, datefrom, dateto).subscribe((result: any) => {
            this.listTransactions = result.Result;
            this.count = result.Count;
            this.isEmpty = (this.count == 0) ? true : false;
            //console.log(this.listTransactions);
            //  this.transData.statementlist = this.listTransactions;
            this.transData.changeList(this.listTransactions);

            this.transData.accountnumber = this.accountnumber;
            this.transData.screen = 'statement';
            this.isLoading = false;

        }, error => {
            this.isLoading = false;
            this.isEmpty = true;
            //console.log('Error occured: ' + error);

        })


    }

    GetInvoice(invnumber) {
        // this.router.navigate(['/carrier/invoice/', this.accountnumber, referencenumber]);
        this.router.navigate(['/carrier/invoice/' + this.accountnumber + '/' + invnumber + '/' + this.carrierid]);
    }

    getDebtorAccount(custcode: string) {

        this.carrierService.getDebtorAccount(custcode).subscribe((result: any) => {

            this.debtoraccount = result;
            this.count = result.Count;
            console.dir(this.debtoraccount);
            this.transData.debtoraccount = this.debtoraccount;

        }, error => {
            //console.log('Error occured: ' + error);
        })

    }


    onSearch() {

        //console.log(this.dateTo);
        //console.log(this.dateFrom);
        this.loadAccounts(this.accountnumber, this.dateFrom, this.dateTo);

    }

    getCarrier() {
        this.carrierService.carrierPersonByuserId(Number(this.user.Id)).subscribe((result: any) => {
            this.person_id = result.person_id;
            this.transData.personid = this.person_id;
            //console.log(result);
        }, error => {
            //console.log(error);
        });
    }


}
